import type { HeadingLevel } from './rich-text-title';

const HEADING_LEVELS: readonly HeadingLevel[] = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];

// 1:1 passthrough of Blacklight's `heading-levels` selection widget, which offers
// h1–h6 plus a blank option. Blacklight types the fields `String!` and resolves an
// unset property to `''`, so the empty string is that blank option — see
// `resolveHeadingLevel` for how it maps back onto the AC's default.
export type HeadingLevelOption = HeadingLevel | '';

/**
 * Blacklight types heading-level fields as `String!` and resolves an unset
 * property to `''` (see `experienceDetailsHeadingLevel: productProperties.… || ''`
 * in the collections GraphQL queries), so the component receives an empty string
 * — never `undefined`, never `null` — whenever the author has not picked a level.
 *
 * The `heading-levels` selection widget only ever offers `h1`–`h6`, so `''` is the
 * AC's "null" option, and the AC's own "Default to H2 / H3" rule is what applies
 * in that case. Falling back keeps the page's heading outline intact for legacy
 * content instead of silently dropping a heading.
 */
export function resolveHeadingLevel(
	value: HeadingLevelOption | undefined,
	fallback: HeadingLevel
): HeadingLevel {
	return HEADING_LEVELS.includes(value as HeadingLevel) ? (value as HeadingLevel) : fallback;
}
